import { useEffect, useRef, useState } from 'react';
import { IconColumns } from './icons';

// Small "which columns are visible" dropdown, e.g. for a Transaction Detail table —
// checkbox per column, closes on outside click. `columns` is [{ key, label }], `visible`
// is { [key]: boolean }, `onChange` receives the next visible map on every toggle.
export default function ColumnToggle({ columns, visible, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  function toggle(key) {
    onChange({ ...visible, [key]: visible[key] === false ? true : false });
  }

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="p-1.5 rounded border border-gray-300 bg-white hover:bg-gray-50 text-gray-600"
        title="Show/hide columns"
        aria-label="Show/hide columns"
      >
        <IconColumns width={16} height={16} />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-20 py-1">
          {columns.map((c) => (
            <label
              key={c.key}
              className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={visible[c.key] !== false}
                onChange={() => toggle(c.key)}
                className="rounded border-gray-300"
              />
              {c.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
